export default () => ({
  status,
  terms: {},
  termsLang: "",
  title: "",
});
